export const payload = ({ face_params }) => {

    return {
        model: process.env.REACT_APP_MODEL,
        messages: [
            {
                role: "system",
                content: "You are a professional and inclusive makeup advisor. Always suggest safe, diverse, flattering options, and avoid medical advice."
            },
            {
                role: "user",
                content: `Based on the following features:
    - Hair color: ${face_params.hair_color}
    - Skin tone: ${face_params.skin_tone}
    - Eye color: ${face_params.eye_color}
    - Lip shape: ${face_params.lip_color}

    Suggest the most flattering makeup look for a user based on their hair color, skin tone, eye color, and lip color.
    Recommend 3 options for each makeup product: foundation, blush, eyeshadow, eyeliner, and lipstick.

    For each suggestion, include:
    - The official shade code and number for widely recognized brands (e.g., MAC NC30, Maybelline 220).
    - Wrap around each makeup product with <b><a class="ai-link" href="link_to_product">...</a></b>.
    - The makeup title should be wrapped with <h1><b>...</b></h1>.
    - Add a <hr> after each set of makeup suggestions.
    - An explanation of why this shade is suited to the user's features (e.g., undertones, contrast, harmony).
    - Brief tips for application if relevant (e.g., finish type, layering technique).

    The recommendations should reflect the highest color match and complement the user's overall complexion.

    Make sure not to:
    - Suggest to continue the conversation
    - Include introductory or ending comments
    - Include the color name in Hex code
    - Wrap any titles or makeup product with *...* or **...**`
            }
        ],
        frequency_penalty: 0,
        presence_penalty: 0,
        temperature: 0.3,
        stream: true
    }
} 